import { render, staticRenderFns } from "./KpiSettingsActionsMenu.vue?vue&type=template&id=af91a56c"
import script from "./KpiSettingsActionsMenu.vue?vue&type=script&lang=ts"
export * from "./KpiSettingsActionsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports